import React from 'react'
function BannerInfo() {
  return (
    
<div className="panel-horizontal-content" style={{ backgroundColor: '#F3F6F9' }}>
  <div className="panel-horizontal">
    <div className="card-body">
      <h2 className="card-title">¿QUÉ ES UNA IDE?</h2>
      <p className="card-text">
      Una Infraestructura de Datos Espaciales (IDE) es un conjunto de recursos interrelacionados
dedicados a gestionar Información Geográfica accesibles mediante la web, cumpliendo una serie
de condiciones de interoperabilidad encuadradas dentro de un marco legal que permiten al
usuario, utilizarlos y combinarlos según sus necesidades.
      </p>
      <div className="panel-footer">
        <p>
        Los componentes básicos y fundamentales de una IDE son:<br/>
- Visor de Datos Geográficos<br/>
- Catálogo de Metadatos<br/>
- Geoservicios: WMS, WFS y WCS
        </p>
      </div>
    </div>
  </div>
</div>

  )
}

export default BannerInfo